export default "__VITE_ASSET__C5FMQq6J__"